import script from "./TurboHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TurboHeader.vue?vue&type=script&setup=true&lang=js"

import "./TurboHeader.vue?vue&type=style&index=0&id=67068b04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67068b04"]])

export default __exports__